export default __webpack_public_path__ + "static/media/line.4914c38e.png";